import Odometer from 'odometer';
import ScrollMagic from 'scrollmagic';
import Controller from '@/scripts/utils/scrollmagic/controller';
import selectors from '@/scripts/animation/animation-selectors';
import 'odometer/themes/odometer-theme-default.css';
import './counter.scss';

const getAssets = el => ({
  counter: el.querySelector(selectors.counterNumber),
});

const initOdometer = (el, frac) => new Odometer({
  el,
  value: 0,
  format: frac ? `(ddd).${frac.split('').map(() => 'd').join('')}` : 'd',
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-animation*="counter-item"]').forEach((wrapper) => {
    const { counter } = getAssets(wrapper);
    let odometer;
    if (counter) {
      const text = $(counter).text();
      if (!isNaN(text)) { // eslint-disable-line no-restricted-globals
        const [, frac] = text.split('.');
        $(counter).data('value', text);
        odometer = initOdometer(counter, frac, text);
      }
    }

    return new ScrollMagic.Scene({
      triggerElement: wrapper,
      triggerHook: 'onEnter',
      offset: 50,
      reverse: false,
    })
      .on('start', () => {
        if (odometer) {
          odometer.update($(counter).data('value'));
        }
        $(wrapper).addClass('is-loaded');
      })
      .addTo(Controller);
  });
});



// WEBPACK FOOTER //
// ./scripts/utils/scrollmagic/scenes/counter/counter.js